export function Banner() {
  return (
    <section className="relative w-full h-[20vh] overflow-hidden">
      <video
        className="absolute inset-0 w-full h-full object-cover"
        autoPlay
        muted
        loop
        playsInline
        preload="metadata"
      >
        <source src="/video/banner.mp4" type="video/mp4" />
        Ваш браузер не поддерживает HTML5 видео.
      </video>

      <div className="absolute inset-0 bg-black/30" />
    </section>
  );
}
